import ChatMasterPage from '../../../app/chat/components/ChatMasterPage.vue'

export default [
  {
    path: 'chat',
    name: 'config.chat.master',
    component: ChatMasterPage,
    meta: {
      acl: 'chat_master'
    }
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/chat/routes.js